import React from 'react';
import Footer from '../../components/footer/Footer';
import FooterMob from '../../components/footer/FooterMob';
import MobNav from '../../components/Mobnav/MobNav';
import Navbar from '../../components/navbar/Navbar';
import logo from '../../images/white-logo.png';
import MobForm from './MobForm';
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-bootstrap/Modal";

import "react-toastify/dist/ReactToastify.css";
import { useState } from 'react';
import { baseUrl } from '../../context/BaseUrl';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const InstRegister = () => {
    

    const [Email, setEmail] = useState("");
    const [Password, setPassword] = useState("");
    const [PhoneReg, setPhoneReg] = useState("");
    const [NameReg, setNameReg] = useState("");
    const [EmailReg, setEmailReg] = useState("");
    const [PasswordReg, setPasswordReg] = useState("");
    const navigate = useNavigate();


    const handleSignup = async (role) => {
        try {
          // const id = toast.loading("Processing...");
          // if (EmailReg && PhoneReg && NameReg && PasswordReg.length > 8) {
          const response = await fetch(`${baseUrl}/signup`, {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: EmailReg,
              password: PasswordReg,
              role: role,
              mobile: PhoneReg,
              name: NameReg,
            }),
          });
    
          const result = await response.json();
    
          if (result.code == 500) {
            toast.error(result.msg);
    
            return;
          }
    
          toast.success("You're registered successfuly");
    
          if (role == "institute") {
            // navigate("https://obepedia-institute.netlify.app")
            window.location.href = "https://obepedia-institute.netlify.app";
            return;
          }
    
          // }
        } catch (error) {
          toast.error("Internal Server Error !!", {
            position: toast.POSITION.TOP_LEFT,
          });
        }
      };

    return (

        <>
        <ToastContainer />
       <div className="upsc-background home-background">
                <div className="logged">
                    <Navbar logoimg={logo} />
                </div>
            </div>
            <MobNav dnone="d-none" />


            <div className="container">
                <div className="login-page login-form py-5">
                    {/* <MobForm title='Register as Intitute' btn='Register' account='Login' with='Or Register In with' /> */}
                    <Form>
                <Modal.Header >
                  <h4>Register as Institute</h4>
                </Modal.Header>

                <Form.Group className="mb-4">
                  <Form.Control
                    id="name"
                    onChange={(e) => setNameReg(e.target.value)}
                    value={NameReg}
                    placeholder="Full Name *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="number"
                    onChange={(e) => setPhoneReg(e.target.value)}
                    value={PhoneReg}
                    placeholder="Mobile Number *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="email"
                    onChange={(e) => setEmailReg(e.target.value)}
                    value={EmailReg}
                    placeholder="Email ID *"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    id="Password"
                    onChange={(e) => setPasswordReg(e.target.value)}
                    value={PasswordReg}
                    placeholder="Password *"
                  />
                </Form.Group>
                <button
                  type="button"
                  onClick={() => handleSignup("institute")}
                  className="signbtn"
                >
                  {" "}
                  Register{" "}
                </button>
                <Form.Group className="mb-4">
                  <a
                    href="https://obepedia-institute.netlify.app"
                    className="acct"
                  >
                    Login As Institute
                  </a>
                </Form.Group>
              </Form>
                </div>
            </div>

            <Footer /><FooterMob />
        </>


    )
}

export default InstRegister